import { TrendingUp, TrendingDown, ArrowRight, Sparkles } from 'lucide-react';
import type { Observation } from './types';

type Props = {
  observations: Observation[];
};

const DIRECTION_CONFIG = {
  improving: { icon: TrendingUp, className: 'text-green-600 dark:text-green-400' },
  worsening: { icon: TrendingDown, className: 'text-red-600 dark:text-red-400' },
  stable: { icon: ArrowRight, className: 'text-muted-foreground' },
  new: { icon: Sparkles, className: 'text-blue-600 dark:text-blue-400' },
} as const;

export function ReviewObservations({ observations }: Props) {
  if (observations.length === 0) return null;

  return (
    <div>
      <h3 className="text-sm font-medium mb-2">Osservazioni</h3>
      <ul className="space-y-2">
        {observations.map((obs, i) => {
          const config = DIRECTION_CONFIG[obs.direction] || DIRECTION_CONFIG.stable;
          const Icon = config.icon;
          return (
            <li key={i} className="flex items-start gap-2 text-sm">
              <Icon className={`size-4 shrink-0 mt-0.5 ${config.className}`} />
              <span>{obs.observation}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
